import { AsyncPipe } from '@angular/common';
import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatAnchor, MatButton, MatIconAnchor } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatToolbar } from '@angular/material/toolbar';
import { MatTooltip } from '@angular/material/tooltip';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from 'projects/cupcake/src/environments/environment';
import { Observable } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { SubSink } from 'subsink';
import { AuthService } from '../../core/auth/auth.service';
import { AutoUnsubscribe } from '../../core/auto-unsubscribe';
import { UserInfo, UserInfoService } from '../../core/user-info.service';
import { AccountRouteNames } from '../../shared/routing.constants';
import { BreadcrumbWrapperComponent } from '../breadcrumb/breadcrumb.component';
import { LanguageSelectComponent } from '../language-select/language-select.component';

@AutoUnsubscribe()
@Component({
  selector: 'app-top-navigation-bar',
  templateUrl: './top-navigation-bar.component.html',
  styleUrls: ['./top-navigation-bar.component.scss'],
  imports: [
    MatToolbar,
    MatAnchor,
    RouterLinkActive,
    RouterLink,
    MatIcon,
    MatIconAnchor,
    MatTooltip,
    MatButton,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    MatDivider,
    LanguageSelectComponent,
    BreadcrumbWrapperComponent,
    AsyncPipe,
    TranslateModule,
    MatProgressBarModule,
  ],
})
export class TopNavigationBarComponent implements AfterViewInit {
  accountRouteNames = AccountRouteNames;

  subs = new SubSink();

  appName = environment.appNameInNavigationBar;
  appNameColor = environment.appNameColorNavigationBar;

  @ViewChild(MatInput)
  search?: MatInput;

  catalogSearchForm = this.formBuilder.group({
    searchText: [''],
  });

  searchTextControl = this.catalogSearchForm.get('searchText');

  public get userInfo(): Observable<UserInfo | undefined> {
    return this.userInfoService.getUserInfo();
  }

  public get isAuthenticated(): Observable<boolean> {
    return this.userInfoService.isAuthenticated();
  }

  constructor(
    public loader: LoadingBarService,
    private authService: AuthService,
    private userInfoService: UserInfoService,
    private formBuilder: FormBuilder,
    private router: Router
  ) {}

  onLogout() {
    this.subs.sink = this.authService.signOut().subscribe(s => {
      if (s)
        this.router.navigate([
          AccountRouteNames.ModuleBase,
          AccountRouteNames.Login,
        ]);
    });
  }

  ngAfterViewInit(): void {
    this.subs.sink = this.catalogSearchForm.valueChanges
      .pipe(debounceTime(500))
      .subscribe(s => {
        this.router.navigate(['catalog'], {
          queryParams: { q: s.searchText },
        });
      });
  }
}
